import { Box, IconButton, Modal, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import { AppointmentParticipant } from "./appointmentParticipantTypes";
import ParticipantContactStack from "./ParticipantContactStack";

type Props = {
  open: boolean;
  onClose: () => void;
  type: "participants" | "organizers" | null;
  names: string[];
  participants?: AppointmentParticipant[];
};

const ViewNamesModal = ({
  open,
  onClose,
  type,
  names,
  participants = [],
}: Props) => {
  const showParticipantContacts =
    type === "participants" && participants.length > 0;

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="view-names-modal">
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 450,
          bgcolor: "background.paper",
          borderRadius: "12px",
          boxShadow: 24,
          p: 0,
          maxHeight: "80vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 2.5,
            borderBottom: "1px solid #E5E7EB",
          }}
        >
          <Typography fontSize={18} fontWeight={700} color="text.primary">
            {type === "participants" ? "All Participants" : "Internal Team"}
          </Typography>
          <IconButton
            onClick={onClose}
            size="small"
            sx={{
              color: "text.secondary",
              "&:hover": { bgcolor: "action.hover" },
            }}
          >
            <Close fontSize="small" />
          </IconButton>
        </Box>

        <Box
          sx={{
            p: 2.5,
            overflowY: "auto",
            flexGrow: 1,
          }}
        >
          {showParticipantContacts ? (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
              {participants.map((participant, index) => (
                <Box
                  key={index}
                  sx={{
                    py: 1.5,
                    px: 2,
                    bgcolor: "#F9FAFB",
                    borderRadius: "8px",
                  }}
                >
                  <ParticipantContactStack participant={participant} />
                </Box>
              ))}
            </Box>
          ) : names.length > 0 ? (
            <Box
              component="ul"
              sx={{
                listStyle: "none",
                p: 0,
                m: 0,
              }}
            >
              {names.map((name, index) => (
                <Box
                  component="li"
                  key={index}
                  sx={{
                    py: 1.5,
                    px: 2,
                    mb: 1,
                    bgcolor: "#F9FAFB",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "text.primary",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <Box
                    sx={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      bgcolor: "primary.main",
                      flexShrink: 0,
                    }}
                  />
                  {name}
                </Box>
              ))}
            </Box>
          ) : (
            <Typography color="text.secondary" textAlign="center">
              No names available
            </Typography>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default ViewNamesModal;
